import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { SEARCH_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useSearchCarsSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useSearchAuctionResume() {
  const { startListen } = useWebSocketStore()
  const { updateSearchCar } = useUpdateCar()

  const auctionResume = () => {
    startListen({
      eventName: 'premium.AUCTION_RESUME',
      callbackName: SEARCH_SOCKET_CALLBACK,
      callback: (event) => {
        const { auctionId, resumeTime } = event.context

        updateSearchCar(auctionId, (data) => {
          const newTime = new Date(resumeTime * 1000).toISOString()

          return {
            ...data,
            auctionStartDate: newTime,
          }
        })
      },
    })
  }

  return { auctionResume }
}
